export const globalGetters = {
  schools: 'school/schools'
}

export const getters = {
  schools: state => state.schools
}
